import regionFragment from "../fragments/region";

const regionQuery = `region->
    ${regionFragment}     
`;

export default regionQuery;
